import { useContext } from 'react';
import PropTypes from 'prop-types';
import { TabsContext } from "../context";
export var DeviceTabContent = function DeviceTabContent(_ref) {
  var children = _ref.children,
    id = _ref.id;
  var activeTab = useContext(TabsContext);
  if (activeTab !== id) {
    return null;
  }
  return children;
};
DeviceTabContent.propTypes = {
  children: PropTypes.node,
  id: PropTypes.number
};